// "Empty" for disabling Save/Rename on a blank draft: nothing meaningful beyond a heading marker.
// `# ` → empty, `# Hello` → not empty.
const isEmptyMarkdown = (md: string): boolean => md.replace(/^\s*#+\s*/, '').trim() === '';

export default isEmptyMarkdown;
